function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgViewOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14c-1.922 0-3.618-.603-5.092-1.646C1.916 11.65 1.213 10.917.5 10c-.568-.757-.566-2.248.013-3.013.698-.9 1.405-1.638 2.398-2.34C4.385 3.602 6.081 3 8 3c1.92 0 3.615.603 5.09 1.646.992.703 1.699 1.44 2.41 2.354.565.753.567 2.239-.008 3.016-.712.91-1.41 1.636-2.402 2.338C11.617 13.397 9.92 14 8 14Zm0-1c3.8 0 6-2.7 6.705-3.6.296-.4.296-1.4-.004-1.8C14 6.7 11.799 4 8 4S2.002 6.7 1.303 7.6c-.302.4-.302 1.4-.002 1.8C2 10.3 4.198 13 8 13ZM4.5 8.499a3.5 3.5 0 1 1 6.998 0 3.5 3.5 0 0 1-6.998 0Zm6 0a2.5 2.5 0 1 0-5 .003 2.5 2.5 0 0 0 5-.003Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgViewOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgViewOutlinedIcon);
export default Memo;